<ng-container
  *ngrxLet="installationFeaturesStore.selectUpdateFeatureLoading$ | async as featureLoading"
>
  <div class="flex w-full my-4 mb-12 min-h-[120px]">
    <!-- one time -->
    <div class="w-1/2 mr-1 relative">
      <app-feature-list-container>
        <div class="flex flex-col gap-2">
          <div>
            <p class="time-limit">
              {{ 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.ONE_TIME.TIME_LIMIT' | translate }}
            </p>
          </div>
          <h3>
            {{ 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.ONE_TIME.TITLE' | translate }}
          </h3>
          <ng-container *ngIf="!feature.properties.active.value; else oneTimeDefrostingRunning">
            <div class="flex flex-col justify-between gap-3">
              <p>{{ 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.ONE_TIME.DESCRIPTION' | translate }}</p>
              <app-banner
                *ngIf="defrostProcessFinished"
                [type]="BannerType.success"
                isFullWidth="true"
              >
                <p>
                  {{
                    'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.NOTIFICATION.SUCCESS_TITLE' | translate
                  }}
                </p>
                <p>
                  {{
                    'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.NOTIFICATION.SUCCESS_DESCRIPTION'
                      | translate
                  }}
                </p>
              </app-banner>

              <button
                mat-raised-button
                color="primary"
                class="connection-button fill-btn w-fit !flex flex-row justify-center items-center lt-md:order-1"
                gtm="onTriggerOneTimeDefrost"
                gtmCategory="RemoteTriggerDefrost"
                gtmAction="Trigger one time defrost"
                data-at-one-time-trigger-defrost
                *ngIf="feature.commands.setActive.isExecutable"
                [disabled]="featureLoading"
                [viConfirm]="{
                  title: 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.MODAL.TITLE' | translate,
                  content: 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.MODAL.DESCRIPTION' | translate,
                  cancelBtn: 'GENERAL.BUTTON.CANCEL' | translate,
                  confirmBtn:
                    'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.MODAL.CONFIRM_BUTTON' | translate
                }"
                (confirm)="triggerOneTimeDefrost()"
                (cancel)="cancelOneTimeDefrost()"
              >
                <ng-container>
                  <span>{{ 'HEATING_COOLING_CIRCUIT_REMOTE_DEFROST.BUTTON' | translate }} </span>
                  <mat-spinner *ngIf="featureLoading"></mat-spinner>
                </ng-container>
              </button>
            </div>
          </ng-container>
        </div>
      </app-feature-list-container>
    </div>

    <ng-template #oneTimeDefrostingRunning>
      <app-defrosting-process-running [feature]="feature"></app-defrosting-process-running>
    </ng-template>
  </div>
</ng-container>
